/**
 * Feature flags — 출시 게이팅 (단일 진실원)
 *
 * QUESTIONS(문제은행/시험지/HWPX-OCR 파이프라인)는 강사 개인 자산 독립 앱으로
 * 분리 중(트랙2~3, exam-hwp-pipeline 핸드오프). academy 출시 빌드에서는 숨기되,
 * dev 에서는 계속 개발할 수 있게 노출한다.
 *
 * 우선순위 (markdownParser.ts 선례 미러):
 *   1) 환경변수 `VITE_QUESTIONS_ENABLED` 가 명시되면 그 값을 따름 (강제 토글)
 *   2) dev 모드 → 자동 노출 (트랙2 개발 연속성)
 *   3) production → 숨김 (출시)
 *
 * @module core/config/featureFlags
 */

// Vite 의 정적 치환을 받기 위해 직접 접근.
const VITE_QUESTIONS = import.meta.env["VITE_QUESTIONS_ENABLED"] as string | undefined;
const PROC_QUESTIONS =
  typeof process !== "undefined" ? process.env?.["VITE_QUESTIONS_ENABLED"] : undefined;

const EXPLICIT_QUESTIONS = VITE_QUESTIONS ?? PROC_QUESTIONS;
const IS_DEV = import.meta.env.DEV === true;

/**
 * 문제집(QUESTIONS) 모듈 노출 여부.
 * 명시 env 우선 → 없으면 dev 노출 / prod 숨김.
 */
export const QUESTIONS_ENABLED: boolean =
  EXPLICIT_QUESTIONS !== undefined ? EXPLICIT_QUESTIONS === "true" : IS_DEV;

// Vite 의 정적 치환을 받기 위해 직접 접근.
const VITE_INK = import.meta.env["VITE_INK_ENABLED"] as string | undefined;
const PROC_INK =
  typeof process !== "undefined" ? process.env?.["VITE_INK_ENABLED"] : undefined;

const EXPLICIT_INK = VITE_INK ?? PROC_INK;

/**
 * 잉크(INK) AI 어시스턴트 모듈 노출 여부.
 * 서버 ink-agent(Claude tool-loop)는 작동하나 클라이언트가 Sprint 1 수준(저장·tool 투명성·
 * rich_card 렌더 미완)이라 출시 빌드에서는 숨긴다. dev 에서는 노출해 찰나가 개발·테스트.
 * 충분히 완성+테스터 검증 후 prod 공개 (env `VITE_INK_ENABLED=true` 또는 dev 기본값 제거).
 * 명시 env 우선 → 없으면 dev 노출 / prod 숨김 (QUESTIONS 선례 미러).
 */
export const INK_ENABLED: boolean =
  EXPLICIT_INK !== undefined ? EXPLICIT_INK === "true" : IS_DEV;
